import { Outlet } from 'react-router-dom'
import ChatbotSuporte from '../components/ChatbotSuporte'
import Header from '../components/Header'
import ModalGerenciadorFiscal from '../components/ModalGerenciadorFiscal'
import { useMenu } from '../contexts/menu'

export function DefaultLayout() {
    const {
        mostrarGerenciadorFiscal,
        modeloFiscalGerenciador,
        dadosGerenciadorFiscal,
        fecharGerenciadorFiscal,
        notificarAutorizacaoFiscal,
    } = useMenu()

    return (
        <div>
            <Header />
            <Outlet />
            <ChatbotSuporte />
            {mostrarGerenciadorFiscal && (
                <ModalGerenciadorFiscal
                    modeloInicial={modeloFiscalGerenciador}
                    idNota={dadosGerenciadorFiscal?.idNota}
                    status={dadosGerenciadorFiscal?.status}
                    operacaoInicial={dadosGerenciadorFiscal?.operacaoInicial}
                    numeroNotaInicial={dadosGerenciadorFiscal?.numeroNota}
                    valorNotaInicial={dadosGerenciadorFiscal?.valorNota}
                    onFechar={fecharGerenciadorFiscal}
                    onAutorizada={notificarAutorizacaoFiscal}
                />
            )}
        </div>
    )
}

// Adicionando exportação default para corrigir o erro de importação
export default DefaultLayout
